import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import React, { Suspense } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import ErrorBoundary from '~/App/components/ErrorBoundary';
import Header from '~/App/components/Header';
import Loading from '~/App/components/Loading';
import Wrapper from '~/App/components/Wrapper';
import api from '../../api';
import { UserFormValues } from '../../types';
import message from '~/utils/message';
import UserForm from '../../components/UserForm';

const EditUserContent = ({ id }: { id: string }) => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchUserById', id],
    queryFn: () => api.getUserById(id),
    staleTime: 0,
    gcTime: 0,
  });
  const navigate = useNavigate();

  const { isPending, mutate } = useMutation({
    mutationFn: (values: UserFormValues) => api.updateUser(id, values),
    retry: false,
    onSuccess: () => {
      message.success('Success edit user');
      navigate('..');
    },
    onError: (e) => {
      message.error(e.message ?? 'Fail to edit user');
    },
  });

  return (
    <UserForm initialValues={data} loading={isPending} onSubmit={mutate} />
  );
};

const EditUser = () => {
  const { id } = useParams();
  if (!id) return <Navigate to=".." />;
  return (
    <Wrapper className="max-w-[800px]">
      <Header title="Edit User" />
      <ErrorBoundary>
        <Suspense fallback={<Loading className="h-[400px]" />}>
          <EditUserContent id={id} />
        </Suspense>
      </ErrorBoundary>
    </Wrapper>
  );
};

export default EditUser;
